import {Link} from 'react-router-dom';
export default function Billionaires() {
  return (
    <>
      <div id="billionaires" className="container-fluid">
        <div className="row">
          <div className="col-sm-7">
            <h1 className="banner-head billion_heading main_billion_head">
              What is <br />
              <img src={"images/new/billion-logo.png"} alt="billi_logo" className="billi_logo" />?
            </h1>
            <b>
              <p className="banner-para billio_para-first first">
                <b>Little Billionaires </b>is a generative 3D art NFT project
                with the main focus on added value for the holder
              </p>
            </b>
            <p className="banner-para billio_para-second">
              Little Billionaires provides you with a <br />
              state-of-the-art ecosystem circulating around <br />
              the <b>$LITTLE</b> token, which finds its added
              <br /> value in a variety of use cases even before
              <br /> the official listing
            </p>
            <Link to="/little-token">
              <button className="custom-btn btn-banner billion_button header">
                WHAT'S $LITTLE TOKEN
              </button>
            </Link>
          </div>
          <div className="col-sm-5 picture">
            <img src={"images/new/3.png"} alt="billionaire" className="billio_img floating" />
          </div>
        </div>
      </div>
    </>
  );
}
